import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';

export default function SelectModulo(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsModulos, setLsModulos] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };


    function handleModulo(codigo, modulo){
        props.setCdModulo(codigo)
        props.setDsModulo(modulo)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectModulo(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderModulos(){
            const {data} = await api_gateway.get('/m1/consultar/modulo');
            
            if(data.dados.length > 0){
                let objetoModulos = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_pav_modulo}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleModulo(item.cd_pav_modulo, item.ds_pav_modulo) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_pav_modulo}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsModulos(objetoModulos)
            }else{
                let objetoModulos = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsModulos(objetoModulos)
            }
            setSpinAtivo(false)
        }
        renderModulos()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }  
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectModulo(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsModulo}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsModulos}
                </ul>
            </div>
        </Form>
    )
}